import { Address } from 'viem';
import { useEthPrice } from './useEthPrice';
import { USDC_CONTRACT_ADDRESS } from '~/core/constants';

export const useCurrencyPrice = (currency: Address) => {
  const { data, isLoading, error } = useEthPrice()
  if (currency === USDC_CONTRACT_ADDRESS) 
    return { data: 1, isLoading, error }
  return { data, isLoading, error }
}
